function extractVideoIdFromYTUrl(url: string): string | undefined {
  const videoIdMatch = url.match(
    /(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:shorts\/|[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|apiplayer\?video_id=)|youtu\.be\/|youtube-nocookie\.com\/embed\/)([a-zA-Z0-9_-]{11})/
  )
  if (!videoIdMatch || !videoIdMatch[1]) return
  return videoIdMatch[1]
}

export default extractVideoIdFromYTUrl
